























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import '@/types';

import { DxDataGrid, DxColumn, DxEditing, DxStateStoring, DxColumnChooser, DxColumnFixing, DxSearchPanel, DxFilterRow, DxExport, DxGroupPanel } from 'devextreme-vue/data-grid';

@Component({
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxStateStoring,
    DxColumnChooser,
    DxColumnFixing,
    DxSearchPanel,
    DxFilterRow,
    DxExport,
    DxGroupPanel,
  },
})
export default class DefaultDatagrid extends Vue {
  public selectedRows: any = [];
  @Prop({ required: false, default: false })
  public enableSelection?: boolean;

  @Prop({ required: false, default: false })
  public allowExport!: boolean;

  @Prop({ required: false, default: false })
  public remoteOperations?: boolean;

  @Prop({ required: true })
  public name?: string;

  @Prop({ required: true })
  public columns?: any[];

  @Prop({ required: true })
  public datasource?: any;

  @Prop({ required: false, default: null })
  public grouping?: any;

  @Prop({ required: false, default: false })
  public allowDeleting?: boolean;

  @Prop({ required: false, default: false })
  public allowEditing?: boolean;

  @Prop({ required: false, default: false })
  public allowAdding?: boolean;

  @Prop({ required: false, default: true })
  public onRowRemoving?: any;

  @Prop({ required: false, default: true })
  public onRowInit?: any;

  @Prop({ required: false, default: true })
  public onRowUpdating?: any;

  @Prop({ required: false, default: true })
  public onRowInserting?: any;

  @Prop({ required: false, default: true })
  public onRowUpdated?: any;

  @Prop({ required: false, default: true })
  public onRowClick?: any;

  @Prop({ required: false, default: true })
  public onRowInserted?: any;

  @Prop({ required: false, default: true })
  public onRowRemoved?: any;

  @Prop({ required: false, default: () => () => true })
  public onEditorPreparing?: any;

  @Prop({ required: false, default: null })
  public onCellClick?: any;

  @Prop({ required: false, default: null })
  public onCellPrepared?: any;

  @Prop({ required: false, default: null })
  public onRowPrepared?: any;

  @Prop({ required: false, default: 'row' })
  public editMode?: string;

  @Prop({ required: false, default: false })
  public small?: boolean;

  @Prop({ required: false, default: false })
  public medium?: boolean;

  @Prop({ required: false, default: false })
  public toolbarOptions?: any[];

  @Prop({ required: false, default: null })
  public rowDragging?: any;

  @Prop({ required: false, default: true })
  public showSearchPanel?: any[];

  @Prop({ required: false, default: false })
  public groupPanelvisible?: boolean;

  @Prop({ required: false, default: null })
  public onContentReady?: (e: any) => void;

  @Prop({ required: false, default: true })
  public enableToolbar?: boolean;

  @Prop({ required: false, default: null })
  public onSelectionChanged?: (e: any) => void;

  @Prop({ required: false, default: null })
  public onInitialized?: (e: any) => void;

  public showFilter: boolean = true;

  public paging: any = {
    pageSize: 20,
  };
  public pager: any = {
    showPageSizeSelector: true,
    allowedPageSizes: [10, 20, 50],
    visible: true,
  };

  public loadState() {
    if (!this.name) {
      return null;
    }

    let state: any = localStorage.getItem(this.name);
    if (state) {
      state = JSON.parse(state);
      if (state && state.selectedRowKeys && Array.isArray(state.selectedRowKeys) && state.selectedRowKeys.length > 0) {
        state.selectedRowKeys = [];
      }

      if (state.hasOwnProperty('searchText')) {
        state.searchText = '';
      }
    }

    return state;
  }

  public saveState(state: any) {
    if (this.name) {
      localStorage.setItem(this.name, JSON.stringify(state));
    }
  }

  public rowInit(e: any) {
    if (this.onRowInit && typeof this.onRowInit === 'function') {
      this.onRowInit(e);
    }
  }

  public rowInserted(e: any) {
    if (this.onRowInserted && typeof this.onRowInserted === 'function') {
      this.onRowInserted(e);
    }
  }

  public rowUpdated(e: any) {
    if (this.onRowUpdated && typeof this.onRowUpdated === 'function') {
      this.onRowUpdated(e);
    }
  }

  public rowClick(e: any) {
    if (this.onRowClick && typeof this.onRowClick === 'function') {
      this.onRowClick(e);
    }
  }

  public rowRemoved(e: any) {
    if (this.onRowRemoved && typeof this.onRowRemoved === 'function') {
      this.onRowRemoved(e);
    }
  }

  public rowRemoving(e: any) {
    if (this.onRowRemoving && typeof this.onRowRemoving === 'function') {
      this.onRowRemoving(e);
    }
  }

  public rowUpdating(e: any) {
    if (this.onRowUpdating && typeof this.onRowUpdating === 'function') {
      this.onRowUpdating(e);
    }
  }

  public rowInserting(e: any) {
    if (this.onRowInserting && typeof this.onRowInserting === 'function') {
      this.onRowInserting(e);
    }
  }

  public cellPreparedFunction(e: any) {
    if (this.onCellPrepared) {
      this.onCellPrepared(e);
    }
  }

  public rowPreparedFunction(e: any) {
    if (this.onRowPrepared) {
      this.onRowPrepared(e);
    }
  }

  public contentReady(e: any) {
    if (this.onContentReady) {
      this.onContentReady(e);
    }

    this.checkClearFilterButtonStyle();
  }

  public selectionChanged(e: any) {
    if (this.onSelectionChanged) {
      this.onSelectionChanged(e);
    }
  }

  public initialized(e: any) {
    if (this.onInitialized) {
      this.onInitialized(e);
    }
  }

  get height() {
    if (this.small) {
      return 400;
    }

    if (this.medium) {
      return 600;
    }
    // return 600;
  }

  public onToolbarPreparing(e: any) {
    if (!this.enableToolbar) {
      e.toolbarOptions.visible = false;
      return;
    }

    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'fas fa-filter',
        onClick: this.toggleFilter,
      },
    });

    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'fas fa-filter-circle-xmark',
        onClick: this.removeFilters,
        elementAttr: {
          id: 'clearFilterButton',
        },
        onContentReady: this.checkClearFilterButtonStyle,
      },
    });

    if (this.toolbarOptions) {
      this.toolbarOptions.forEach((element) => {
        e.toolbarOptions.items.push(element);
      });
    }
  }

  checkClearFilterButtonStyle() {
    setTimeout(() => {
      const dataGrid = (this.$refs[this.name ?? ''] as DxDataGrid).instance;
      if (dataGrid) {
        const isFiltered = dataGrid.getCombinedFilter() !== undefined;
        const buttonElement = document.getElementById('clearFilterButton');

        if (buttonElement) {
          const iconElement = buttonElement.querySelector('.dx-icon');
          if (iconElement) {
            if (isFiltered) {
              iconElement.classList.add('filtered-icon');
              iconElement.classList.remove('unfiltered-icon');
            } else {
              iconElement.classList.add('unfiltered-icon');
              iconElement.classList.remove('filtered-icon');
            }
          }
        }
      }
    }, 0);
  }

  public removeFilters() {
    const dataGrid = (this.$refs[this.name ?? ''] as DxDataGrid).instance;
    if (dataGrid) {
      dataGrid.clearFilter();
      this.checkClearFilterButtonStyle();
    }
  }

  public toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  get selectionMode() {
    if (this.enableSelection) {
      return {
        mode: 'multiple',
        showCheckBoxesMode: 'always',
        deferred: false,
      };
    }
  }
}
